import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const platform = Capacitor.getPlatform(); // "ios", "android", or "web"

if (environment.production) {
  enableProdMode();
}

if (platform === 'android') {
  const guard = document.createElement('div');
  guard.className = 'inset-guard';
  guard.setAttribute('aria-hidden', 'true');
  document.body.appendChild(guard);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));